import { postContent } from './api-helper';

const searchActionsUrl = `${process.env.REACT_APP_RESOURCE_MANAGER_API}/actions/search`;

export const searchPermittedActions = async (actions) => {
  const response = await postContent(searchActionsUrl, { actions });
  // The RM V3 contract (3.2.1, POST /permissions/actions/search) documents the response as { actions: string[] },
  // but the API does not match it and returns a plain string[]. Accept both; anything else means no permissions.
  const permittedActions = Array.isArray(response) ? response : response?.actions;
  return Array.isArray(permittedActions) ? permittedActions : [];
};
